module.exports = __webpack_public_path__ + "static/media/TN.95b4bb25.svg";